// lib
import { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/question-views/vq/Component'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/vq/styles/Component.module.scss'

const ModeToggle = ({ mode, processing, toggleDisabled, onModeChange }) => {
  const { data, disabled } = useContext(DataContext)

  const basicDisabled = useMemo(
    () => !data.options.some(group => 0 < group.items.length) || disabled,
    [data.options, disabled]
  )

  const onClick = event =>
    onModeChange(
      'advanced' == mode ? 'basic' : 'advanced',
      event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey
    )

  return basicDisabled ? null : 'advanced' == mode ? (
    <span
      className={`${style['group-toggle']}${toggleDisabled ? ' ' + style['group-toggle-disabled'] : ''}`}
      {...pressable(toggleDisabled || processing ? null : onClick)}
    >
      {toggleDisabled ? 'Simplify/clear logic to switch to the basic mode' : 'switch to basic mode'}
    </span>
  ) : (
    <span className={style['group-toggle']} {...pressable(onClick)}>
      switch to advanced mode
    </span>
  )
}

ModeToggle.propTypes = {
  mode: PropTypes.string,
  processing: PropTypes.bool,
  toggleDisabled: PropTypes.bool,
  onModeChange: PropTypes.func
}

ModeToggle.displayName = 'ModeToggle'

export default ModeToggle
